import * as React from 'react';
import { TooltipContent } from '../../components/Notification/TooltipContent';
import { CustomTooltip } from '@cian/ui-kit';
import { useDispatch } from 'react-redux';
import { hideNotification } from '../../actions';
import { DescriptionContainer } from './DescriptionContainer';
import { ButtonContainer } from './ButtonContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export function TooltipContainer(_ref) {
  var isAuthenticated = _ref.isAuthenticated,
    isOpen = _ref.isOpen,
    onWaitForLogin = _ref.onWaitForLogin,
    buttonRef = _ref.buttonRef,
    placement = _ref.placement,
    onClickFolderName = _ref.onClickFolderName;
  var dispatch = useDispatch();
  return /*#__PURE__*/_jsx(CustomTooltip, {
    content: /*#__PURE__*/_jsx(TooltipContent, {
      description: /*#__PURE__*/_jsx(DescriptionContainer, {
        onClickFolderName: onClickFolderName
      }),
      button: /*#__PURE__*/_jsx(ButtonContainer, {
        isAuthenticated: isAuthenticated,
        onWaitForLogin: onWaitForLogin
      })
    }),
    outside: true,
    anchorRef: buttonRef,
    arrow: true,
    portal: true,
    open: isOpen,
    theme: "black",
    placement: placement ? placement : 'bottom-start',
    flip: false,
    preventOverflow: false,
    maxWidth: 400,
    onClose: function onClose() {
      return dispatch(hideNotification());
    },
    size: "S"
  });
}